var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.439 14.7479C7.36952 17.2674 11.7807 16.925 14.2913 13.9791C16.802 11.0332 16.4583 6.60276 13.5278 4.08322C10.5973 1.56368 6.18612 1.90608 3.67548 4.85202C1.16485 7.79796 1.50849 12.2284 4.439 14.7479ZM3.14173 16.2701C6.80224 19.4173 12.2565 19.091 15.5232 15.6017L19.9015 19.3661C20.3203 19.7261 20.9502 19.6772 21.3084 19.2569C21.6666 18.8366 21.6176 18.2039 21.1988 17.8439L16.7243 13.9969C18.9005 10.2972 18.1876 5.452 14.8251 2.56102C11.056 -0.679459 5.3852 -0.237508 2.15893 3.54815C-1.06734 7.33381 -0.627322 13.0296 3.14173 16.2701ZM8.9 6.39258C9.17614 6.39258 9.4 6.61644 9.4 6.89258V8.99219H11.5C11.7761 8.99219 12 9.21605 12 9.49219C12 9.76833 11.7761 9.99219 11.5 9.99219H9.4V11.8926C9.4 12.1687 9.17614 12.3926 8.9 12.3926C8.62386 12.3926 8.4 12.1687 8.4 11.8926V9.99219H6.5C6.22386 9.99219 6 9.76833 6 9.49219C6 9.21605 6.22386 8.99219 6.5 8.99219H8.4V6.89258C8.4 6.61644 8.62386 6.39258 8.9 6.39258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.bdd8b632f6ad8f6648d26637cf5e6268.svg";
export { ForwardRef as ReactComponent };